import React from "react";
import "./Charges.css";
import { TextField } from "@mui/material";
import { MenuItem } from "@mui/material";
import { useState, useEffect } from "react";
 import axios from "axios";
import { ToastContainer,toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Cookies from 'js-cookie';
import { url } from "../../../../../App";

const Charges = ({ loanData }) => {
  const [open, setOpen] = React.useState(false);
  // const [query, setQuery] = useState("");
  // const [leads, setLeads] = useState([]);
  // const [rowNumber, setRowNumber] = useState(10);
  // var [pageCount, setPageCount] = useState(1);
  // const [loanId, setloanId] = useState("");
  // const [mobileNumber, setmobileNumber] = useState("");
  const token = Cookies.get('Token');
  const email = Cookies.get('Email');
  const [statusModal, setstatusModal] = useState(false);
  const [charges, setcharges] = useState("");
  const [chargeAmount, setchargeAmount] = useState(null);
  const [referenceNumber, setreferenceNumber] = useState("");
  const [collectionDate, setcollectionDate] = useState("");
  const [paymentType, setpaymentType] = useState("");
  const [initiateDate, setInitiateDate] = useState(null);
  const [chargeDetails, setChargeDetails] = useState([]);
  const [selectedCharge, setSelectedCharge] = useState(null);
  const [loanTerms, setLoanTerms] = useState("");

  useEffect(() => {

    setOpen(true);

    const fetchLoanData = async () => {
      try {

        const loanTermsResponse = await axios.post(url + `/loan/getloanterms`, {
          loan_id: loanData.loan_id,
          email: email,
          token: token
        });
        const { data: loanTermsData } = loanTermsResponse;
        setLoanTerms(loanTermsData.message);
  
        const chargesResponse = await axios.post(url + `/loan/getCharges`, {
          loan_id: loanData.loan_id,
          email: email,
          token: token
        });
        const { data: chargesData } = chargesResponse;
        setChargeDetails(Array.isArray(chargesData.message) ? chargesData.message : []);

      } catch (error) {
        console.error("Error fetching loan data", error);
        
      } finally {
        setOpen(false);
      }
    }

    fetchLoanData();

    // if (loanTerms) {

    //   if (charges === "IMD Charges") {
    //     setchargeAmount(10);
    //   } else if (charges === "Stamp Charges") {
    //     setchargeAmount(20);
    //   } else {
    //     setchargeAmount(0);
    //   }
    // }

  }, [loanData, charges, email, token]);

  useEffect(() => {
    if (loanTerms && Array.isArray(loanTerms.loan_fees_arr)) {
      const imdPresent = loanTerms.loan_fees_arr.find(item => item.loanfees_name === "IMD ADVANCE");
      console.log(imdPresent);
      if (imdPresent && charges === "IMD Charges") {
        setchargeAmount(parseInt(imdPresent.loanfees_amt));
      }

      const stampPresent = loanTerms.loan_fees_arr.find(item => item.loanfees_name === "STAMP CHARGES");
      console.log(stampPresent);
      if (stampPresent && charges === "Stamp Charges") {
        setchargeAmount(parseInt(stampPresent.loanfees_amt));
      }
    }
  }, [loanTerms, charges]);

  console.log(loanData);
  console.log(loanTerms);

  const togglestatusModal = (item) => {
    setstatusModal(!statusModal);
    setSelectedCharge(item);
  };

  // const paginationViewHandler = (e) => {
  //   parseInt(setRowNumber(e.target.value));
  // };

  // const getPageLoad = (e) => {
  //   // setOpen(true);
  //   if (e === "inc") {
  //     setPageCount((pageCount) => pageCount + 1);
  //   } else {
  //     setPageCount((pageCount) => pageCount - 1);
  //   }
  // };

  const cancelFunction = () => {
    setstatusModal(!statusModal);
  };

  const handleCharges = async (e) => {
    e.preventDefault();
    setOpen(true);

    try {
      const findBorrowerDetails = await axios.post(url + `/borrower/getsingle`, {
        borrower_uniqueno: loanData?.borrower_uniqueno,
        email: email,
        token: token
      });
      console.log(findBorrowerDetails);
  
      const chargeInitiate = await axios.post(url + `/loan/initiateCharges`, {
        token: token,
        email: email,
        loan_id: loanData?.loan_id,
        mobile_number: findBorrowerDetails?.data[0]?.borrower_mobile,
        add_charges: charges,
        charge_amount: chargeAmount,
        charge_date: initiateDate,
        createdDate: new Date(),
        borrowerName: loanData?.borrower_name,
        borrowerEmail: findBorrowerDetails?.borrower_email
      });
  
      console.log(chargeInitiate.data);
      if (chargeInitiate.data.auth === true) {
        toast.success(chargeInitiate.data.message);
        axios.post(url + `/loan/getCharges`, {
          loan_id: loanData.loan_id,
          email: email,
          token: token
        }).then((res) => {
          console.log(res);
          const {data} = res;
          const {message} = data;
          setChargeDetails(Array.isArray(message) ? message : []);
        })
      } else {
        toast.error(chargeInitiate.data.message);
      }
      setOpen(false);
    } catch (err) {
      console.log(err);
      setOpen(false);
    }
  };

  // const handlePaymentSource = (e) => {
  //   e.preventDefault();
  //   setOpen(true);
  //   axios
  //     .post("http://localhost:5000/add/payment", {
  //       token: token,
  //       email: email,
  //       reference_number: referenceNumber,
  //       collection_date:collectionDate,
  //       payment_type:paymentType
  //     })

  //     .then((res) => {
  //       console.log(res.data);
  //       setOpen(false);
  //     })

  //     .catch((err) => {
  //       setOpen(false);
  //       toast.error(err.message);
  //     });
  // };


  // const deleteCharges = (e) => {
  //   setOpen(true);
  //   axios
  //     .post("http://localhost:5000/delete/charges", {
  //       token: token,
  //       email: email,
  //       // loan_id: loanId,
  //     })

  //     .then((res) => {
  //       console.log(res.data);
  //       setOpen(false);
  //     })

  //     .catch((err) => {
  //       setOpen(false);
  //       toast.error(err.message);
  //     });
  // };

  const formattedDate = (date) => {
    let formatDate;
    if (date) {
      const dateObj = new Date(date);
      const day = dateObj.getUTCDate().toString().padStart(2, '0');
      const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, '0');
      const year = dateObj.getUTCFullYear();
      formatDate = `${day}-${month}-${year}`;
    }
    return formatDate;
  }

  const handlePayment = async (item, refNumber, collecDate , type) => {
    try {
      setOpen(true);
      const sendPaymentDetails = await axios.post(url + `/loan/updateCharges`, {
        chargeId: item.chargeUniqueNumber,
        refNo: refNumber,
        collDate: collecDate,
        source: type,
        email: email,
        token: token
      });
      
      if (sendPaymentDetails.data.auth === true) {
        toast.success(sendPaymentDetails.data.message);
        axios.post(url + `/loan/getCharges`, {
          loan_id: item.loanId,
          email: email,
          token: token
        }).then((res) => {
          console.log(res);
          const {data} = res;
          const {message} = data;
          setChargeDetails(Array.isArray(message) ? message : []);
          setcollectionDate("");
          setpaymentType("");
          setreferenceNumber("");
        })
        setstatusModal(false);
      } else {
        toast.error(sendPaymentDetails.data.message);
      }
      setOpen(false);
    } catch (err) {
      console.log(err);
    }
  }

  const copyLink = async (link) => {
    const textArea = document.createElement("textarea");
    try {
      if (!link) {
        toast.error("Link not found");
        return;
      }
      textArea.value = link;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      toast.success("Link Copied");
    } catch {
      toast.info(`Error copying the text`);
    }
  }

  return (
    <>
      <div className="charges">
        <form onSubmit={handleCharges}>
          <div className="applicant-row">
            <div className="nominee-inp">
              <label htmlFor="dob">Add Charges</label>
              <TextField
                className="lms-input-field"
                placeholder="Select Borrower"
                required
                select
                name="gender"
                variant="outlined"
                size="small"
                value={charges}
                onChange={(e) => setcharges(e.target.value)}
              >
                <MenuItem value="IMD Charges">IMD Charges</MenuItem>
                <MenuItem value="Stamp Charges">Stamp Charges</MenuItem>
              </TextField>
            </div>
            <div className="nominee-inp">
              <label htmlFor="first-nominee-name">Charge Amount</label>
              <TextField
                className="lms-input-field"
                size="small"
                type="text"
                variant="outlined"
                id="first-nominee-name"
                name="first-nominee-name"
                value={chargeAmount}
                onChange={(e) => setchargeAmount(e.target.value)}
              />
            </div>
            <div className="nominee-inp">
              <label htmlFor="first-nominee-name">Charge Initiate Date</label>
              <TextField
                className="lms-input-field"
                size="small"
                type="date"
                variant="outlined"
                id="first-nominee-name"
                name="first-nominee-name"
                required
                value={initiateDate}
                onChange={(e) => setInitiateDate(e.target.value)}
                inputProps={{
                  max: new Date().toISOString().split("T")[0],
                }}
            />
            </div>
          </div>

          <button type="submit" className="Initiate-btn-top">
            Initiate Payment
          </button>
        </form>
        <div className="table-lead-input-fieldss">
          {/* <div className="table-head-inputs"> */}
            {/* <label>Search Data</label> */}
            {/* <TextField
              placeholder="Loan Id"
              name="search-data"
              id="search-data"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              variant="outlined"
              size="small"
            /> */}
          {/* </div> */}

          {/* <button className="digi-kyc" onClick={serachDateApi}>
            Search
          </button> */}
        </div>

        <div className="lms-table-div">
          <table className="lms-table">
            <thead>
              <tr>
                <th>Unique ID</th>
                {/* <th>Loan Id</th> */}
                {/* <th>Mobile</th> */}
                <th>Charge</th>
                <th>Amount</th>
                <th>Initiate Date</th>
                {/* <th>Created Date</th> */}
                <th>Initiated By</th>
                <th>Actions</th>
                {/* <th>Delete</th> */}
                <th>Status</th>
                <th>Reference</th>
                <th>Collection Date</th>
                <th>Mode</th>
              </tr>
            </thead>
            <tbody>
              {chargeDetails?.map((items) => (
                <tr key={items.chargeUniqueNumber}>
                  <td>{items.chargeUniqueNumber}</td>
                  {/* <td>{items.loanId}</td> */}
                  {/* <td>{items.mobileNumber}</td> */}
                  <td>{items.chargeName ?? items.chargesReason}</td>
                  <td>{items.chargeAmount}</td>
                  <td>{formattedDate(items.dateOfInitiate)}</td>
                  {/* <td>{formattedDate(items.createdDate)}</td> */}
                  <td>{items.createdBy}</td>
                  <td>
                    <button
                      className={`${items.chargeStatus === "Initiated" ? 'Initiate-btn' : 'disabled-btn'}`}
                      onClick={() => togglestatusModal(items)}
                      disabled={items.chargeStatus !== "Initiated"}
                    >
                      Paid Entry
                    </button>
                    <button
                      className={`${items.chargeStatus === "Initiated" ? 'Initiate-btn' : 'disabled-btn'}`}
                      onClick={() => copyLink(items.paytmUrl)}
                      disabled={items.chargeStatus !== "Initiated"}
                    >
                      Copy Link
                    </button>
                  </td>
                  {/* <td><button className="Initiate-btn"
                  onClick={() => deleteCharges()}
                  >
                    Delete
                  </button>
                  </td> */}
                  <td>{items.chargeStatus}</td>
                  <td>{items.referenceNumber}</td>
                  <td>{formattedDate(items.dateOfCollection)}</td>
                  <td>{items.collectionSource}</td>
                  <td></td>
                </tr>
            ))}
            </tbody>
          </table>
        </div>
        {/* <div className="pagination-div">
          <div className="pagination-select">
            <label>Entries To Display</label>
            <TextField
              className=""
              placeholder="rows"
              select
              name="created-data"
              variant="outlined"
              value={rowNumber}
              size="small"
              onChange={paginationViewHandler}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={25}>25</MenuItem>
              <MenuItem value={50}>50</MenuItem>
            </TextField>
          </div>
          <div className="pagination-bar">
            <button
              className="digi-kyc"
              style={{ marginLeft: "1rem" }}
              onClick={() => getPageLoad("dec")}
              disabled={pageCount === 1}
            >
              Previous
            </button>
          </div>
          <span className="pageCount" style={{ margin: "1rem" }}>
            {pageCount}
          </span>
          <div className="pagination-bar">
            <button className="digi-kyc" onClick={() => getPageLoad("inc")}>
              Next
            </button>
          </div>
        </div> */}
        {statusModal && (
          <div className="modal overlay">
            <div className="status-content">
              <h2 style={{ width: "100%", textAlign: "center" }}>
                Payment Source
              </h2>
              {/* <form onSubmit={handlePayment(referenceNumber,collectionDate,paymentType)} > */}
              <div className="lms-table-div-modal">
                <div>
                  <label>Reference Number</label>
                  <br></br>
                  <TextField
                    className="report-field"
                    required
                    name="status-type"
                    variant="outlined"
                    value={referenceNumber}
                    size="small"
                    sx={{ width: "50ch", backgroundColor: "white" }}
                    onChange={(e) => setreferenceNumber(e.target.value)}
                  ></TextField>
                </div>
                <br></br>
                <div>
                  <label>Collection Date</label>
                  <br></br>
                  <TextField
                    type="date"
                    required
                    className="report-field"
                    name="status-type"
                    variant="outlined"
                    value={collectionDate}
                    size="small"
                    sx={{ width: "50ch", backgroundColor: "white" }}
                    onChange={(e) => setcollectionDate(e.target.value)}
                    inputProps={{
                        max: new Date().toISOString().split("T")[0],
                    }}
                  ></TextField>
                </div>
                <br></br>
                <div>
                  <label>Payment Type</label>
                  <br></br>
                  <TextField
                    className="report-field"
                    placeholder="Select Data..."
                    select
                    name="status-type"
                    variant="outlined"
                    value={paymentType}
                    size="small"
                    sx={{ width: "50ch", backgroundColor: "white" }}
                    onChange={(e) => setpaymentType(e.target.value)}
                  >
                    <MenuItem value="UPI">UPI</MenuItem>
                    <MenuItem value="BANK TRANSFER">Bank Transfer</MenuItem>
                    <MenuItem value="CASH">Cash</MenuItem>
                  </TextField>
                </div>
                <br></br>
              </div>
              <button className="save-modal" type="submit" onClick={() => handlePayment(selectedCharge, referenceNumber, collectionDate, paymentType)}>
                Submit
              </button>
              <button className="cancel-modal" onClick={cancelFunction}>
                Close
              </button>
              {/* </form> */}
            </div>
          </div>
        )}
      </div>
      <ToastContainer />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default Charges;
